export const deepLinkScheme = 'eskso:';
export const codeLinkScheme = '/eskso-app';
export const startDigits = '9620';
